import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const CameraIcon = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 21 21">
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_153_108764)">
      <path d="M19.9675 16.3333C19.9675 16.7754 19.7919 17.1993 19.4793 17.5118C19.1668 17.8244 18.7428 18 18.3008 18H3.30082C2.85879 18 2.43487 17.8244 2.12231 17.5118C1.80975 17.1993 1.63416 16.7754 1.63416 16.3333V7.16667C1.63416 6.72464 1.80975 6.30072 2.12231 5.98816C2.43487 5.67559 2.85879 5.5 3.30082 5.5H6.63415L8.30082 3H13.3008L14.9675 5.5H18.3008C18.7428 5.5 19.1668 5.67559 19.4793 5.98816C19.7919 6.30072 19.9675 6.72464 19.9675 7.16667V16.3333Z" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.8009 14.6667C12.6418 14.6667 14.1342 13.1743 14.1342 11.3333C14.1342 9.49238 12.6418 8 10.8009 8C8.95991 8 7.46753 9.49238 7.46753 11.3333C7.46753 13.1743 8.95991 14.6667 10.8009 14.6667Z" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
      <clipPath id="clip0_153_108764">
      <rect width="20" height="20" fill="white" transform="translate(0.800842 0.5)"/>
      </clipPath>
      </defs>
      </svg>
    </SvgIcon>
  );
}

export default CameraIcon;